<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important" toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <button @click="goBack" class="back-button">Back</button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}
            <b-badge v-if="preq_is_converted === '1'" :variant="'success'">Converted</b-badge>
          </b-navbar-brand>
        </b-navbar>

        <div class="card formCard">
          <div class="navbar">
            <div class="navbar-brand">
              Shipping Details Form
              <b-button v-if="preq_is_converted == 0" @click="addShippers(null)" size="sm">
                <i class="fa fa-plus-circle ml-1"></i>
              </b-button>
            </div>
          </div>
          <b-row>
            <b-col md="3">
              <label><b v-if="preq_is_converted === '1'">Job No : {{ JobNo }}</b></label>
            </b-col>
            <b-col md="3">
              <label><b v-if="preq_is_converted === '1'">Job Date : {{ JobDate }}</b></label>
            </b-col>
          </b-row>
          <div v-if="preq_is_converted == 0">
            <b-row v-for="(shipper, index) in shippersArr" :key="index">
              <b-col md="2">
                <label>Shipper Type {{ parseInt(index) + 1 }}</label>
                <model-list-select :isDisabled="preq_is_converted == 1 || shipper.preq_cm_id > 0"
                  :list="shipperTypeList" :style="{
                    borderColor: shipper.shipper_type_err ? 'red' : '',
                  }" v-model="shipper.shipper_type" option-value="val" option-text="text"
                  placeholder="Select Shipper Type" @input="toggleShipperInput(index)"></model-list-select>
                <span class="error" v-if="shipper.shipper_type_err">{{
                  shipper.shipper_type_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Shipper Name {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1 || shipper.preq_cm_id > 0" :style="{
                  borderColor: shipper.shipper_name_err ? 'red' : '',
                }" v-if="shipper.shipper_type === 'new'" type="text" v-model="shipper.shipper_name"
                  placeholder="Enter Shipper Name" />
                <model-list-select :isDisabled="preq_is_converted == 1 || shipper.preq_cm_id > 0" :style="{
                  borderColor: shipper.shipper_name_err ? 'red' : '',
                }" v-if="shipper.shipper_type === 'existing'" :list="$store.getters['common/getAllClientList']"
                  v-model="shipper.fk_client_id" option-value="clientId" option-text="clientName"
                  placeholder="Select Shipper Name"
                  @input="getShpperNameId(index, shipper.fk_client_id)"></model-list-select>
                <span class="error" v-if="shipper.shipper_name_err">{{
                  shipper.shipper_name_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Contact Person Name {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1 || shipper.preq_cm_id > 0" :style="{
                  borderColor: shipper.contact_person_name_err ? 'red' : '',
                }" type="text" v-model="shipper.contact_person_name" placeholder="Enter Contact Person Name" />
                <span class="error" v-if="shipper.contact_person_name_err">{{
                  shipper.contact_person_name_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Contact Email {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1 || shipper.preq_cm_id > 0" :style="{
                  borderColor: shipper.contact_email_err ? 'red' : '',
                }" type="email" v-model="shipper.contact_email" placeholder="Enter Contact Email" />
                <span class="error" v-if="shipper.contact_email_err">{{
                  shipper.contact_email_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Contact Mobile {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1 || shipper.preq_cm_id > 0" :style="{
                  borderColor: shipper.contact_mobile_err ? 'red' : '',
                }" type="number" v-model="shipper.contact_mobile" placeholder="Enter Contact Mobile" />
                <span class="error" v-if="shipper.contact_mobile_err">{{
                  shipper.contact_mobile_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Expected Volume {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1" :style="{
                  borderColor: shipper.expected_volume_err ? 'red' : '',
                }" type="text" v-model="shipper.expected_volume" placeholder="Enter Expected Volume" />
                <span class="error" v-if="shipper.expected_volume_err">{{
                  shipper.expected_volume_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Cargo Readiness Estimated Date {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1" :style="{
                  borderColor: shipper.cargo_estimated_readiness_date_err ? 'red' : '',
                }" type="date" v-model="shipper.cargo_estimated_readiness_date" placeholder="Select Date" />
                <span class="error" v-if="shipper.cargo_estimated_readiness_date_err">{{
                  shipper.cargo_estimated_readiness_date_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Estimated Date of Arrival at Port {{ parseInt(index) + 1 }}</label>
                <b-form-input :disabled="preq_is_converted == 1" :style="{
                  borderColor: shipper.estimated_arrival_at_port_date_err ? 'red' : '',
                }" type="date" v-model="shipper.estimated_arrival_at_port_date" placeholder="Select Date" />
                <span class="error" v-if="shipper.estimated_arrival_at_port_date_err">{{
                  shipper.estimated_arrival_at_port_date_err
                }}</span>
              </b-col>
              <b-col md="2">
                <label>Cargo Arrival at Port {{ parseInt(index) + 1 }} </label>
                <b-form-input :disabled="preq_is_converted == 1" :style="{
                  borderColor: shipper.cargo_arrival_at_port_err ? 'red' : '',
                }" type="date" v-model="shipper.cargo_arrival_at_port" placeholder="Select Date" /><span class="error"
                  v-if="shipper.cargo_arrival_at_port_err">{{
                    shipper.cargo_arrival_at_port_err
                  }}</span>
              </b-col>
              <b-col md="3">
                <label>Remark {{ parseInt(index) + 1 }}</label>
                <b-textarea :disabled="preq_is_converted == 1" :style="{ width: '200px' }" v-model="shipper.remarks"
                  placeholder="Enter Remarks" rows="3"></b-textarea>
              </b-col>
              <b-col md="2" v-if="
                shipper.preq_cm_id > 0 &&
                shipper.preq_cm_is_active == 1 &&
                shipper.isKYC == 'No'
              ">
                <label>Client Status {{ parseInt(index) + 1 }}</label>
                <model-list-select :disabled="preq_is_converted == 1" :list="clientStatusList"
                  v-model="shipper.preq_cm_is_active" option-value="val" option-text="text"
                  placeholder="Select Client Status" @input="activateClient(shipper)"></model-list-select>
              </b-col>
              <b-col md="1">
                <label>Action</label>
                <!-- index > 0 &&  -->
                <b-button v-if="shipper.preq_cm_id <= 0" size="sm" @click="removeShippers(index)">
                  <i class="fa fa-minus-circle" aria-hidden="true"></i>
                </b-button>
                <h6>
                  <b-badge v-if="shipper.PrerequisiteClientStatus === 'New'" :variant="'success'">{{
                    shipper.PrerequisiteClientStatus }}</b-badge>
                </h6>
              </b-col>
              <hr />
            </b-row>
          </div>
          <div class="shipper-table" v-if="preq_is_converted == 1 && preq_id > 0">
            <table>
              <thead>
                <tr>
                  <th class="purple-gradient">SN</th>
                  <th class="purple-gradient">Shipper Type</th>
                  <th class="purple-gradient">Shipper Name</th>
                  <th class="purple-gradient">Contact Person Name</th>
                  <th class="purple-gradient">Contact Email</th>
                  <th class="purple-gradient">Contact Mobile</th>
                  <th class="purple-gradient">Expected Volume</th>
                  <th class="purple-gradient">Cargo Readiness Estimated Date</th>
                  <th class="purple-gradient">Estimated Date of Arrival at Port</th>
                  <th class="purple-gradient">Cargo Arrival at Port</th>
                  <th class="purple-gradient">Remark</th>
                  <th class="purple-gradient">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(shipper, index) in shippersArr" :key="index" class="fade-in">
                  <td>{{ parseInt(index) + 1 }}</td>
                  <td>{{ shipper.shipper_type }}</td>
                  <td>{{ shipper.shipper_name }}</td>
                  <td>{{ shipper.contact_person_name }}</td>
                  <td>{{ shipper.contact_email }}</td>
                  <td>{{ shipper.contact_mobile }}</td>
                  <td>{{ shipper.expected_volume }}</td>
                  <td>{{ shipper.cargo_estimated_readiness_date }}</td>
                  <td>{{ shipper.estimated_arrival_at_port_date }}</td>
                  <td>{{ shipper.cargo_arrival_at_port }}</td>
                  <td>{{ shipper.remarks }}</td>
                  <td>
                    <h6>
                      <b-badge :variant="'success'">{{
                        shipper.PrerequisiteClientStatus
                      }}</b-badge>
                    </h6>
                    <h6>
                      <b-badge :variant="shipper.PrerequisiteMapStatus === 'Active'
                        ? 'success'
                        : 'danger'
                        ">{{ shipper.PrerequisiteMapStatus }}</b-badge>
                    </h6>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-responsive tableMain" v-if="getAlLogList.length > 0">
            <b-table show-empty stacked="md" :items="getAlLogList" :fields="fields" responsive primary-key="log_id"
              class="position-relative">
              <template slot="log_id" slot-scope="row0">
                <span>
                  {{ row0.index + 1 }}
                </span>
              </template>
            </b-table>
          </div>
          <div class="form-row centered-buttons" v-if="preq_is_converted == 0">
            <div class="form-col">
              <center>
                <button v-if="shippersArr.length > 0" class="save-button" @click="saveShippingDetails">
                  Save
                </button>
                <button v-if="preq_id > 0 && preq_is_converted == 0" class="save-button"
                  @click="convertConsolidationAss">
                  Convert Consolidation
                </button>
                <button @click="goBack" class="back-button ml-2">Back</button>
              </center>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <div v-if="alert.content" class="alert-dialog">
      <div class="alert-content">
        <p>{{ alert.content }}</p>
        <button @click="closeAlert">{{ alert.ok }}</button>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <div v-if="showModal" class="alert-dialog">
      <div class="alert-content">
        <p>
          There are {{ kycPendingCount }} KYC pending and {{ kycCompletedCount }} KYC
          completed entries. Do you want to proceed?
        </p>
        <b-row>
          <b-col cols="12">
            <label>Numbers of Container<span class="error">*</span></label>
            <b-form-input type="number" :formatter="capitalizeAll" id="no_of_container" name="no_of_container"
              v-model="no_of_container" @input="validateInput"></b-form-input>

          </b-col>
        </b-row>
        <button :disabled="no_of_container <= 0 ? true : false" @click="proceed">Proceed</button>
        <button @click="cancel">Cancel</button>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import AccountService from "../../services/AccountService.js";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    if (
      this.$sessionsStorage.get("editffFclConsoPreqId") != undefined &&
      this.$sessionsStorage.get("editffFclConsoPreqId") != null &&
      this.$sessionsStorage.get("editffFclConsoPreqId") != ""
    ) {
      this.getPrerequisiteList(
        "Normal",
        this.$sessionsStorage.get("editffFclConsoPreqId")
      );
    }

    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/ffExportFclConPreq");
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      no_of_container: 1,
      getAlLogList: [],
      fields: [
        {
          key: "log_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "shipper_name",
          label: "Client",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "field_changed",
          label: "Column Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "old_value",
          label: "Old Value",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "new_value",
          label: "New Value",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "raisedBy",
          label: "Created By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "log_created_at",
          label: "Created Date",
          sortable: true,
          sortDirection: "desc",
        },
      ],

      JobNo: "",
      JobDate: "",
      preq_is_converted: 0,
      preq_id: 0,
      preq_no: "",
      shippersArr: [],
      clientStatusList: [
        {
          val: "0",
          text: "In-Active",
        },
        {
          val: "1",
          text: "Active",
        },
      ],
      shipperTypeList: [
        {
          val: "existing",
          text: "Existing",
        },
        {
          val: "new",
          text: "New",
        },
      ],
      alert: {
        content: "",
        ok: "OK",
      },
      isLoading: false,
      validate: false,

      showModal: false,
      kycPendingCount: 0,
      kycCompletedCount: 0,
    };
  },

  mounted() { },
  beforeDestroy() { },
  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
    MultiSelect,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {},
  methods: {
    validateInput(value) {
      // Only allow whole numbers (integers)
      let parsedValue = parseInt(value, 10);
      if (!isNaN(parsedValue)) {
        const integerValue = parsedValue.replace(/[^0-9]/g, '');
        this.no_of_container = integerValue; // Update v-model with integer-only value
      } else {
        this.no_of_container = ''; // Clear invalid input
      }
    },
    goPreqPage() {
      this.$router.push({
        path: "/ffExportCon/viewFFPrerequisite",
      });
    },
    activateClient(item) {
      let payload = {
        itemCode: "update_client_status",
        preq_id: this.preq_id,
        preq_no: this.preq_no,
        preq_cm_id: item.preq_cm_id,
        fk_client_id: item.fk_client_id,
        shipper_name: item.shipper_name,
        preq_cm_is_active: item.preq_cm_is_active,
      };

      AccountService.getAllPrerequisiteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;

          if (status == 200 && data) {
            this.alert.content = data.MSG;
            // this.$refs["addPop"].open();
            this.goPreqPage();
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on convertConsolidationAss Error: ", error);
        });
    },
    checkKYC() {
      this.kycPendingCount = this.shippersArr.filter(
        (item) => item.isKYC === "No" && item.preq_cm_is_active == 1
      ).length;
      this.kycCompletedCount = this.shippersArr.filter(
        (item) => item.isKYC === "Yes" && item.preq_cm_is_active == 1
      ).length;
      if (this.kycPendingCount > 0) {
        this.showModal = true;
      } else {
        this.showModal = true;
        // this.proceed(); // Proceed if no "No" KYC found
      }
    },
    proceed() {
      this.showModal = false;
      if (this.preq_id > 0 && this.preq_is_converted == 0) {
        // Proceed with saving shipping details
        const filteredData = this.shippersArr
          .filter((item) => item.isKYC === "Yes" && item.preq_cm_is_active == 1)
          .map((item) => ({
            preq_cm_id: item.preq_cm_id,
            fk_preq_id: item.fk_preq_id,
            preq_no: item.preq_no,
            fk_client_id: item.fk_client_id,
            shipper_name: item.shipper_name,
            shipper_type: item.shipper_type,
            preq_cm_is_active: item.preq_cm_is_active,
          }));
        if (this.kycPendingCount > 0) {
          return false;
        } else {
          console.log(filteredData);
          let payload = {
            itemCode: "convertConsolidationAss",
            preq_id: this.preq_id,
            preq_no: this.preq_no,
            preq_is_converted: this.preq_is_converted,
            client_arr: filteredData,
            clientId: filteredData.length > 0 ? filteredData[0].fk_client_id : "",
            no_of_container: this.no_of_container,
          };
          AccountService.getAllPrerequisiteList(payload)
            .then((response) => {
              const { data, status, statusText } = response;

              if (status == 200 && data) {
                this.alert.content = data.MSG;
                // this.$refs["addPop"].open();
                this.goPreqPage();
              }

              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Catch on convertConsolidationAss Error: ", error);
            });
        }
      } else {
        // Show validation errors to the user
        console.log("Please First Add Prequisite");
      }
      // Proceed with the action
    },
    cancel() {
      this.showModal = false;
      // Handle cancellation
    },
    convertConsolidationAss() {
      this.checkKYC();
    },
    getPrerequisiteList(type, preq_id) {
      this.getPrerequisiteItemList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getPrerequisiteList",
        type: type,
        DCfilterId: "",
        searchVal: "",
        DCfilterId: "",
        fromSearch: "",
        currentPage: "",
        perPage: "0",
        Filter: {},
        preq_id: preq_id,
      };

      AccountService.getAllPrerequisiteList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getPrerequisiteList.length > 0) {
                this.totalData = data.totalData;
                this.getPrerequisiteItemList = data.getPrerequisiteList;
                this.shippersArr = data.PrerequisiteClientMapArr;
                this.getAlLogList = data.getPrerequisiteList[0].logArr;
                this.preq_id = data.getPrerequisiteList[0].preq_id;
                this.preq_no = data.getPrerequisiteList[0].preq_no;
                this.preq_is_converted = data.getPrerequisiteList[0].preq_is_converted;
                this.JobNo = data.getPrerequisiteList[0].JobNo;
                this.JobDate = data.getPrerequisiteList[0].JobDate;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getPrerequisiteList.length > 0) {
                this.totalData = data.totalData;
                this.getPrerequisiteItemList = data.getPrerequisiteList;
                this.shippersArr = data.PrerequisiteClientMapArr;
                this.getAlLogList = data.getPrerequisiteList[0].logArr;
                this.preq_id = data.getPrerequisiteList[0].preq_id;
                this.preq_no = data.getPrerequisiteList[0].preq_no;
                this.preq_is_converted = data.getPrerequisiteList[0].preq_is_converted;
                this.JobNo = data.getPrerequisiteList[0].JobNo;
                this.JobDate = data.getPrerequisiteList[0].JobDate;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPrerequisiteList Error: ", error);
        });
    },
    getShpperNameId(index, fk_client_id) {
      let shipperNew = this.$store.getters["common/getAllClientList"].filter((x) => {
        return x.clientId == fk_client_id;
      });
      if (shipperNew.length > 0) {
        this.shippersArr[index].shipper_name = shipperNew[0].clientName;
        this.shippersArr[index].fk_client_id = shipperNew[0].clientId;
      }
    },
    // Method to validate a single shipper object
    validateShipper(shipper) {
      // Validation for shipper_type
      shipper.shipper_type_err = shipper.shipper_type ? "" : "Shipper Type is required";

      // Validation for shipper_name
      shipper.shipper_name_err = shipper.shipper_name ? "" : "Shipper Name is required";

      // Validation for contact_person_name
      shipper.contact_person_name_err = shipper.contact_person_name
        ? ""
        : "Contact Person Name is required";

      // Validation for contact_email
      shipper.contact_email_err = shipper.contact_email
        ? ""
        : "Email Address is required";

      // Validation for contact_mobile
      shipper.contact_mobile_err = shipper.contact_mobile
        ? ""
        : "Mobile Number is required";

      // Validation for expected_volume
      shipper.expected_volume_err =
        shipper.expected_volume && !isNaN(shipper.expected_volume)
          ? ""
          : "Expected Volume is required";

      // Validation for cargo_estimated_readiness_date
      shipper.cargo_estimated_readiness_date_err = shipper.cargo_estimated_readiness_date
        ? ""
        : "Cargo Readiness Estimated Date is required";

      // Validation for estimated_arrival_at_port_date
      shipper.estimated_arrival_at_port_date_err = shipper.estimated_arrival_at_port_date
        ? ""
        : "Estimated Date of Arrival at Port is required";

      // Validation for cargo_arrival_at_port
      // shipper.cargo_arrival_at_port_err = shipper.cargo_arrival_at_port
      //   ? ""
      //   : "Cargo Arrival at Port is required";
    },

    // Method to validate the entire form
    validateForm() {
      // Reset error list
      this.errorList = {};

      // Validate each shipper in the array
      this.shippersArr.forEach((shipper) => {
        this.validateShipper(shipper);
      });

      // Check if there are any validation errors
      // Check if there are any validation errors
      return !this.shippersArr.some((shipper) =>
        Object.keys(shipper).some((key) => key.endsWith("_err") && shipper[key] !== "")
      );
      // return !this.shippersArr.some((shipper) =>
      //   Object.values(shipper).some((err) => err !== "")
      // );
    },

    addShippers() {
      let obj = {
        preq_cm_id: 0,
        fk_preq_id: 0,
        preq_id: 0,
        preq_is_converted: 0,
        preq_no: "",
        shipper_type: "existing",
        fk_client_id: "",
        shipper_name: "",
        contact_person_name: "",
        contact_email: "",
        contact_mobile: "",
        expected_volume: "",
        cargo_estimated_readiness_date: "",
        estimated_arrival_at_port_date: "",
        cargo_arrival_at_port: "",
        remarks: "",

        shipper_type_err: "",
        shipper_name_err: "",
        contact_person_name_err: "",
        contact_email_err: "",
        contact_mobile_err: "",
        expected_volume_err: "",
        cargo_estimated_readiness_date_err: "",
        estimated_arrival_at_port_date_err: "",
        // cargo_arrival_at_port_err: "",
        // remarks_err: "",
      };
      // this.shippersArr.push(obj);
      this.shippersArr.unshift(obj);
    },
    removeShippers(index) {
      this.shippersArr.splice(index, 1);
    },
    goBack() {
      this.$router.go(-1);
    },
    toggleShipperInput(index) {
      // Reset shipper name field when toggling shipper type
      this.shippersArr[index].shipper_name = "";
      this.shippersArr[index].fk_client_id = "";
    },
    saveShippingDetails() {
      // Implement the save functionality here
      // Perform form validation
      if (this.validateForm()) {
        // Proceed with saving shipping details
        let payload = {
          itemCode: "upsertPrerequisite",
          shippers: this.shippersArr,
          preq_id: this.preq_id,
          preq_no: this.preq_no,
          preq_is_converted: this.preq_is_converted,
        };
        AccountService.getAllPrerequisiteList(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              this.alert.content = data.MSG;
              // this.$refs["addPop"].open();
              this.goPreqPage();
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on saveShippers Error: ", error);
          });
      } else {
        // Show validation errors to the user
        console.log("Validation errors:", this.errorList, this.shippersArr);
      }
    },
    closeAlert() {
      this.alert.content = "";
    },
  },
};
</script>
<style scoped>
/* Global Styles */
body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  background: #f0f2f5;
}

/* Container */
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-height: 100vh;
}

/* Loader */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* Card */
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  /* max-width: 1800px; */
  padding: 20px;
  animation: fadeIn 0.5s ease-in-out;
}

/* Navbar */
.navbar {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  background: linear-gradient(45deg, #ff6f61, #ff9068, #ffb086, #ffc494);
  color: #fff;
  padding: 15px 20px;
  border-radius: 8px 8px 0 0;
}

.navbar-brand {
  font-size: 1.5em;
  font-weight: bold;
  /* color: #fff; */
}

/* Form */
.form {
  padding: 20px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.form-col {
  flex: 1;
  min-width: 45%;
  margin-right: 10px;
  margin-bottom: 10px;
}

.form-col:last-child {
  margin-right: 0;
}

label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

input,
textarea {
  width: 100%;
  padding: 18px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  transition: border-color 0.3s;
}

input:focus,
textarea:focus {
  border-color: #2575fc;
}

.error {
  color: red;
  font-size: 9px;
}

/* Centered Buttons */
.centered-buttons {
  display: flex;
  justify-content: center;
}

.save-button,
.back-button {
  background: linear-gradient(45deg, #ff6f61, #ff9068, #ffb086, #ffc494);
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  transition: background 0.3s;
  /* display: flex; */
  align-items: center;
}

.save-button:hover,
.back-button:hover {
  background: linear-gradient(45deg, #ffb086, #ffc494, #ff9068, #ff6f61);
}

.ml-2 {
  margin-left: 10px;
}

/* Alert Dialog */
.alert-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}

.alert-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.alert-content p {
  margin-bottom: 20px;
}

.alert-content button {
  background: #2575fc;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  transition: background 0.3s;
}

.alert-content button:hover {
  background: #6a11cb;
}

/* Shipper Table */
.shipper-table {
  position: relative;
  margin-bottom: 20px;
  overflow-x: auto;
  /* Ensure horizontal scrollbar is visible */
  overflow-y: visible;
  /* Allow vertical overflow */
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  /* position: relative; */
  /* z-index: 1000; Set a high z-index value */
}

th,
td {
  padding: 2px 2px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

thead th {
  background-color: #f2f2f2;
  font-weight: bold;
  text-align: center;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* Animated Row */
/* .fade-in {
  animation: fadeInAnimation 0.5s ease-in-out forwards;
  opacity: 0;
  transform: translateY(20px);
} */

/* Purple Gradient for Table Header */
.purple-gradient {
  background: linear-gradient(to right, #9c27b0, #673ab7);
  color: #fff;
}

/* Adjust the dropdown menu style */
.model-list-select .dropdown-menu {
  position: absolute !important;
  /* Override any fixed or relative positioning */
  z-index: 1000;
  /* Ensure it appears above other elements */
  top: auto;
  /* Ensure dropdown position is relative to the container */
  left: 0;
  right: 0;
  transform: translateY(-100%);
  /* Move it above the input */
  margin-top: 0;
  /* Remove any margin that might push it down */
}

/* Optional: Additional styles to enhance appearance */
.model-list-select .dropdown-menu>.dropdown-item {
  padding: 10px;
  cursor: pointer;
}

.model-list-select .dropdown-menu>.dropdown-item:hover {
  background-color: #f0f0f0;
}

/* Ensure table cells allow overflow */
td {
  overflow: visible !important;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// addPrerequisite.vue?c70b9a58